module.exports = __webpack_public_path__ + "img/browse-vehicles-three-tabs-honda.dd878601.png";